module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAAXNSR0IArs4c6QAAANdJREFUKFPdkqFOBEEQRF9tEHwIWYVA8AEkIJCQgMIys5oEgcHhEPgZe5ZwAoFAIBA4LFnNX3DZIn3hyOZIjmBpVz31ejI1LZaq67pd2w/Amu2jWuvt2KKU0omkjVFzCzj40gG+LM6GYXhXzvl1+ZZVWn8xh3cO5JxvgJ1f4KdSytkCuAP2gGdgH3gDZsCm7XtJMeyxlHI4Buj7/rht249Ip2mame1pKSXeGQP5AUQj52xJ85T+PWB7W9IEuACmwHpEbPtK0mmsyHdKKaVrSeerPi7AWuvlJymmn59YQmN6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/icon_shanchu.png
// module id = rUmQ
// module chunks = 70